export const accountType = ({ type, t }) => {
  switch (type) {
    case "card":
      return t("bank.card");

    case "sheba":
      return t("bank.account");

    default:
      return "";
  }
};

export const numberAccount = ({
  type,
  data,
  withMoreSpace,
  space = "\xa0\xa0\xa0\xa0",
}) => {
  const str = withMoreSpace ? space : " ";
  switch (type) {
    case "card":
      return `${data?.card_number}`.match(/.{1,4}/g)?.join(str);

    case "sheba":
      return data?.account_number;

    default:
      return "";
  }
};

export const paymentMethodType = ({ type, t }) => {
  switch (type) {
    case "card-to-card":
      return t("bank.card-to-card-with-pol");

    case "pol":
      return t("bank.pol");

    case "paya":
      return t("bank.paya");

    case "satna":
      return t("bank.satna");

    case "internal":
      return `${t("bank.internal")}`;

    default:
      return "";
  }
};

export const paymentMethodChecker = ({ bankName, paymentMethod, t, type }) => {
  if (type === "card" && bankName === "MIDDLE_EAST")
    return t("bank.card-to-card-with-internal");

  if (type === "sheba" && bankName === "MIDDLE_EAST") return t("bank.internal");

  return type === "sheba"
    ? `${t("bank.between-bank")}|${paymentMethod}`
    : paymentMethod;
};

export const reasonsDataTransformer = (input) => {
  const data = [];
  input.length &&
    input?.map((item) =>
      data.push({
        label: item?.title,
        value: item?.key,
      })
    );
  return data;
};

export function convertNumberToWords(n) {
  const ones = ["", "یک", "دو", "سه", "چهار", "پنج", "شش", "هفت", "هشت", "نه"];
  const teens = [
    "ده",
    "یازده",
    "دوازده",
    "سیزده",
    "چهارده",
    "پانزده",
    "شانزده",
    "هفده",
    "هجده",
    "نوزده",
  ];
  const hundreds = [
    "یکصد",
    "دویست",
    "سیصد",
    "چهارصد",
    "پانصد",
    "ششصد",
    "هفتصد",
    "هشتصد",
    "نهصد",
  ];
  const tens = [
    "",
    "",
    "بیست",
    "سی",
    "چهل",
    "پنجاه",
    "شصت",
    "هفتاد",
    "هشتاد",
    "نود",
  ];
  const thousands = ["", "هزار", "میلیون", "میلیارد"];

  if (n < 10) {
    return ones[n];
  } else if (n < 20) {
    return teens[n - 10];
  } else if (n < 100) {
    return (
      tens[Math.floor(n / 10)] + (n % 10 === 0 ? "" : " و " + ones[n % 10])
    );
  } else if (n < 1000) {
    return (
      hundreds[Math.floor(n / 100) - 1] +
      (n % 100 === 0 ? "" : " و " + convertNumberToWords(n % 100))
    );
  } else {
    let index = 0;
    let words = "";

    while (n > 0) {
      const part = n % 1000;
      if (part !== 0) {
        words =
          convertNumberToWords(part) +
          " " +
          thousands[index] +
          (words ? " و " + words : "");
      }
      n = Math.floor(n / 1000);
      index++;
    }

    return words.trim();
  }
}
